"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = void 0;
var serviceURL = "/exportservice/v1/api/export";
var config = {
  reportDataExport: serviceURL + "/report/data",
  platformExport: serviceURL + "/platform/user",
  templateExport: serviceURL + "/template",
  systemDataExport: serviceURL + "/system",
  analyticDataExport: serviceURL + "/analytics/record",
  exportData: serviceURL + "/analytics",
  printBridgeExport: serviceURL + "/print-bridge",
  archiveExport: serviceURL + "/archive",
  surveyExport: serviceURL + "/survey"
};
exports.config = config;